import { FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { RoundedButton } from "mds/components/buttons/RoundedButton";
import { PersonGroupIcon } from "mds/icons";
import { storeApi, useAppSelector } from "store/index";
import { pageSelectors, selectIsPageGroupFull, selectPageGroupUserForUser } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

interface ConfirmGroupButtonProps {
  pageId: string;
  userId: string;
}

export const ConfirmGroupButton: FC<ConfirmGroupButtonProps> = ({ pageId, userId }) => {
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["title"]);
  const pageGroupUser = useObjectSelector(
    (s) => selectPageGroupUserForUser(s, pageId, userId),
    ["id", "page_group_id"],
  );
  const isPageGroupFull = useAppSelector((s) =>
    selectIsPageGroupFull(s, pageId, pageGroupUser?.page_group_id),
  );
  const isDisabled = !pageGroupUser || isPageGroupFull;

  if (!page) {
    return null;
  }

  const onConfirmGroup = async () => {
    if (!pageGroupUser) return;
    await storeApi.page_group_users.partial_update({
      id: pageGroupUser.id,
      is_ready: true,
    });
  };

  return (
    <RoundedButton
      disabled={isDisabled}
      eventName="Student Page - Confirm Group"
      eventProps={{ pageTitle: page.title, pageId }}
      kind="success"
      onClick={onConfirmGroup}
    >
      <IconText iconStart={<PersonGroupIcon />} text={t("page_view.confirm_group")} />
    </RoundedButton>
  );
};
